import React from 'react';

interface DeliveryZoneInfoProps {
  className?: string;
}

export function DeliveryZoneInfo({ className = '' }: DeliveryZoneInfoProps) {
  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Service Area Information</h2>
      
      <div className="space-y-6">
        <div className="bg-blue-50 rounded-lg p-4">
          <h4 className="font-semibold text-blue-900 mb-2">Service Area</h4>
          <p className="text-blue-800">
            We provide installation services within 30 miles of our service center in Santa Ana, CA.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="font-semibold text-gray-900 mb-2">Installation Service</h4>
          <ul className="text-gray-700 space-y-2">
            <li>• Professional installation by certified technicians</li>
            <li>• Payment due upon successful installation</li>
            <li>• Installation available Monday through Saturday</li>
          </ul>
        </div>
      </div>
    </div>
  );
}